import { Cell, flexRender, Row } from "react-table-8.10.7";
import { StateData } from "types/Models/nexusTracker";

type MobileNexusTrackerRowProps = {
  row: Row<StateData>;
  onClick: (row: Row<StateData>) => void;
};

// Column ids set on the column helpers in SalesNexusTracker.
const NEXUS_COLUMN_ID = {
  STATE: "jurisdiction",
  SALES: "transactions_amount",
  TRANSACTIONS: "transaction_count",
  STATUS: "status",
  ACTIONS: "actions",
} as const;

const renderCell = (cell?: Cell<StateData, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileNexusTrackerRow = ({
  row,
  onClick,
}: MobileNexusTrackerRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  const handleClick = () => onClick(row);

  return (
    <div
      onClick={handleClick}
      className="t-flex t-cursor-pointer t-flex-col t-gap-3 t-rounded-lg t-border t-border-solid t-border-neutral-0 t-p-3"
    >
      <div className="t-flex t-items-start t-justify-between t-gap-3">
        <div className="t-min-w-0">
          {renderCell(cellsById[NEXUS_COLUMN_ID.STATE])}
        </div>
        <div className="t-shrink-0">
          {renderCell(cellsById[NEXUS_COLUMN_ID.STATUS])}
        </div>
      </div>

      <div className="t-grid t-grid-cols-2 t-gap-3 t-text-body-sm">
        <div className="t-flex t-flex-col t-gap-1">
          <span className="t-text-text-30">Sales</span>
          {renderCell(cellsById[NEXUS_COLUMN_ID.SALES])}
        </div>
        <div className="t-flex t-flex-col t-gap-1">
          <span className="t-text-text-30">Transactions</span>
          {renderCell(cellsById[NEXUS_COLUMN_ID.TRANSACTIONS])}
        </div>
      </div>

      <div className="t-flex t-justify-end">
        {renderCell(cellsById[NEXUS_COLUMN_ID.ACTIONS])}
      </div>
    </div>
  );
};
